import api from "./apiURL";
export async function getUserDetails() {
  try {
    const response = await api.get(`/api/v1/user/userAcquisitions`);
    return response.data;
  } catch (error) {
    // Handle the error
    console.log(error);
  }
}
